import { Vue } from 'vue-property-decorator';

import { ToastReportData } from '@/shared/model/briefing-resource.model';
import { LOADING_DATA_TYPE, MEDIA_LOADING_DATA_TYPE, REPORT_TOAST_STATUS } from '@/constants';
import * as config from '@/shared/config/config';

const store = config.initVueXStore(Vue);

export default class ReportToastUtil extends Vue {
  loadingDataReportToastListLocalStorage = 'loadingDataReportToastListLocalStorage';

  getLoadingDataReportToastListLocalStorage() {
    return localStorage.getItem(this.loadingDataReportToastListLocalStorage) || '';
  }

  setLoadingDataReportToastListLocalStorage(dataListInput: any[]) {
    if (dataListInput?.length > 0) {
      dataListInput = dataListInput.filter((item: ToastReportData) => item.status === REPORT_TOAST_STATUS.LOADING);

      if (dataListInput?.length > 0) {
        localStorage.setItem(this.loadingDataReportToastListLocalStorage, JSON.stringify(dataListInput));
      } else {
        localStorage.setItem(this.loadingDataReportToastListLocalStorage, '');
      }
    } else {
      localStorage.setItem(this.loadingDataReportToastListLocalStorage, '');
    }
  }

  handleRemoveLoadingToastByNotifyDataOrAPIData(requestIdsInput: string[]) {
    if (requestIdsInput?.length > 0) {
      const tempData = this.getLoadingDataReportToastListLocalStorage();

      if (tempData?.length > 0) {
        let parsedData = JSON.parse(tempData);

        if (parsedData?.length > 0) {
          parsedData = parsedData.filter((item: ToastReportData) => !requestIdsInput.includes(item?.requestId));

          if (parsedData?.length > 0) {
            this.setLoadingDataReportToastListLocalStorage(parsedData);
          } else {
            this.setLoadingDataReportToastListLocalStorage([]);
          }
        }
      }
    }
  }

  handleRemoveLoadingReportToastWithListInput(originListInput: any[]) {
    if (originListInput?.length > 0) {
      const tempListRequestId = originListInput
        ?.filter(
          item =>
            item?.type === 'REPORT' &&
            (item?.originParentDocDetail || item.parentDocDetail) &&
            (item?.isLoadingCard === undefined || item?.isLoadingCard === false)
        )
        ?.map(item => item?.requestId?.concat(this.makeConcatStringByMediaType(item)) || '')
        .filter(item => item !== null && item !== undefined && item !== '');

      const firstExistingLoadingData = this.getLoadingDataReportToastListLocalStorage();

      if (firstExistingLoadingData?.length > 0) {
        const firstParsedData = JSON.parse(firstExistingLoadingData);

        if (firstParsedData?.length > 0) {
          if (tempListRequestId?.length > 0) {
            this.handleRemoveLoadingToastByNotifyDataOrAPIData(tempListRequestId);
          }
        }
      }

      if (tempListRequestId?.length > 0) {
        this.handleRemoveToastReportDataStateByRequestIds(tempListRequestId);
      }
    }
  }

  handleRemoveLoadingPodcastToastWithListInput(originListInput: any[]) {
    if (originListInput?.length > 0) {
      const tempListRequestId = originListInput
        ?.filter(
          item =>
            item?.documentType === LOADING_DATA_TYPE.PODCAST.toString() &&
            item.parentDocDetail &&
            (item?.isLoadingCard === undefined || item?.isLoadingCard === false) &&
            (item?.requestId || item?.parentDocDetail?.request_id || item?.parentDocDetail?.data?.request_id || '')
        )
        ?.map(item => ({
          ...item,
          requestId: item?.requestId || item?.parentDocDetail?.request_id || item?.parentDocDetail?.data?.request_id || '',
        }))
        ?.map(item => item?.requestId?.concat('_' + LOADING_DATA_TYPE.PODCAST.toString()) || '')
        .filter(item => item !== null && item !== undefined && item !== '');

      const firstExistingLoadingData = this.getLoadingDataReportToastListLocalStorage();

      if (firstExistingLoadingData?.length > 0) {
        const firstParsedData = JSON.parse(firstExistingLoadingData);

        if (firstParsedData?.length > 0) {
          if (tempListRequestId?.length > 0) {
            this.handleRemoveLoadingToastByNotifyDataOrAPIData(tempListRequestId);
          }
        }
      }

      if (tempListRequestId?.length > 0) {
        this.handleRemoveToastReportDataStateByRequestIds(tempListRequestId);
      }
    }
  }

  handleRemoveToastReportDataStateByRequestIds(requestIdsInput: string[]) {
    if (requestIdsInput?.length > 0) {
      const stateToastReportData = store.getters['appStore/getToastReportData'] || [];

      if (stateToastReportData?.length > 0) {
        const filteredData =
          stateToastReportData?.filter(
            item => item.status !== REPORT_TOAST_STATUS.LOADING || !requestIdsInput?.includes(item?.requestId)
          ) || [];

        if (filteredData?.length > 0) {
          // console.log('logSetToastReportData_9614730825');
          store.commit('appStore/setToastReportData', filteredData);
        } else {
          // console.log('logSetToastReportData_3857901426');
          store.commit('appStore/setToastReportData', []);
        }
      }
    }
  }

  makeConcatStringByMediaType(item: any) {
    if (!item) {
      return '';
    }

    let result = '';
    const prefix = '_';
    const mediaType =
      item?.originParentDocDetail?.media_type ||
      item?.mediaType ||
      item?.parentDocDetail?.mediaType ||
      item?.parentDocDetail?.media_type ||
      [];

    const mediaTypeArray = Array.isArray(mediaType) ? mediaType : [];

    if (mediaTypeArray.length > 0) {
      const hasJournalNote = mediaTypeArray.some(type => type && type.includes(MEDIA_LOADING_DATA_TYPE.JOURNAL_NOTE.toString()));
      const hasSocialMedia = mediaTypeArray.some(type => type && type.includes(MEDIA_LOADING_DATA_TYPE.SOCIAL_MEDIA.toString()));
      const hasPodcast = mediaTypeArray.some(type => type && type.includes(MEDIA_LOADING_DATA_TYPE.PODCAST.toString()));
      const hasReport = mediaTypeArray.some(type => type && type.includes(MEDIA_LOADING_DATA_TYPE.REPORT.toString()));

      if (hasJournalNote) {
        result = LOADING_DATA_TYPE.JOURNALIST_NOTE.toString();
      } else if (hasSocialMedia) {
        result = LOADING_DATA_TYPE.SOCIAL_MEDIA_POSTING.toString();
      } else if (hasPodcast) {
        result = LOADING_DATA_TYPE.PODCAST.toString();
      } else if (hasReport) {
        result = LOADING_DATA_TYPE.REPORT.toString();
      }

      if (result?.length > 0) {
        result = result.replace(/^_+/, '');
        result = prefix + result;
      }
    }

    return result;
  }

  removeLeadingUnderscores(text: string): string {
    try {
      return text.replace(/^_+/, '').replace('_BRIEFING', '');
    } catch (e) {
      return '';
    }
  }
}
